import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["children", "type", "size", "as", "color", "focusColor", "display", "textAlign", "withBackground", "margin", "cursor", "href", "renderIcon"];
var _dec, _class, _Button;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Component } from 'react';
import { getInteraction, passthroughProps } from '@instructure/ui-react-utils';
import { withStyle } from '@instructure/emotion';
import generateComponentTheme from "./theme.js";
import { BaseButton } from "../BaseButton/index.js";
import { allowedProps } from "./props.js";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/**
---
category: components
---
**/
// needed for listing the available theme variables on docs page
let Button = (_dec = withStyle(null, generateComponentTheme), _dec(_class = (_Button = class Button extends Component {
  constructor(...args) {
    super(...args);
    this._buttonComponent = null;
    this.ref = null;
    this.handleElementRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
    this.handleButtonRef = component => {
      this._buttonComponent = component;
    };
  }
  get focused() {
    return this._buttonComponent && this._buttonComponent.focused;
  }
  focus() {
    this._buttonComponent && this._buttonComponent.focus();
  }
  render() {
    const _this$props = this.props,
      children = _this$props.children,
      type = _this$props.type,
      size = _this$props.size,
      as = _this$props.as,
      color = _this$props.color,
      focusColor = _this$props.focusColor,
      display = _this$props.display,
      textAlign = _this$props.textAlign,
      withBackground = _this$props.withBackground,
      margin = _this$props.margin,
      cursor = _this$props.cursor,
      href = _this$props.href,
      renderIcon = _this$props.renderIcon,
      props = _objectWithoutProperties(_this$props, _excluded);
    const interaction = getInteraction({
      props
    });
    const themeOverride = this.props.themeOverride;
    const buttonProps = {
      ...passthroughProps(props),
      type,
      size,
      elementRef: this.handleElementRef,
      ref: this.handleButtonRef,
      as,
      color,
      interaction,
      focusColor,
      display,
      textAlign,
      withBackground,
      margin,
      cursor,
      href,
      renderIcon,
      themeOverride
    };
    return _jsx(BaseButton, {
      ...buttonProps,
      "data-cid": "Button",
      children: children
    });
  }
}, _Button.displayName = "Button", _Button.componentId = 'Button', _Button.allowedProps = allowedProps, _Button.defaultProps = {
  type: 'button',
  size: 'medium',
  as: 'button',
  // Leave interaction default undefined so that `disabled` and `readOnly` can also be supplied
  interaction: void 0,
  color: 'secondary',
  display: 'inline-block',
  textAlign: 'center',
  withBackground: true,
  margin: '0',
  cursor: 'pointer'
}, _Button)) || _class);
export default Button;
export { Button };